import { addLocale, useLocale } from 'ttag';
import React, { Component } from 'react';
import connect from 'react-redux/es/connect/connect';
import LanguageSelector from '../components/languageSelector/LanguageSelectorComponent';
import getLocale from '../services/helper/localeMapping';

class I18nConfig extends Component {

    render() {
    /* eslint-disable global-require */
        if (this.props.locale === '') {
            const typo3LanguageUid = window.languageUid.toString();
            const typo3Locale = getLocale(typo3LanguageUid);
            const typo3TranslationsObj = require(`../../i18n/${typo3Locale}.po.json`); // eslint-disable-line import/no-dynamic-require
            addLocale(typo3Locale, typo3TranslationsObj);
            useLocale(typo3Locale);
            return (<LanguageSelector />);
        }
        const languageUid = this.props.locale;
        const locale = getLocale(languageUid);
        const translationsObj = require(`../../i18n/${locale}.po.json`); // eslint-disable-line import/no-dynamic-require
        addLocale(locale, translationsObj);
        useLocale(locale);
        return (<div>{this.props.children}</div>);
    /* eslint-enable global-require */
    }
}

const mapStateToProps = state => ({
    locale: state.locale,
});
export default connect(mapStateToProps)(I18nConfig);
